/* JY Kelvin — selettore temperatura colore (demo faro + fari dell'hero).
   Mappa Kelvin (3000–7000K) → colore luce (punto bianco blackbody approssimato),
   imposta --jy-kelvin-color su <html>, persiste la scelta in localStorage.
   Controller GLOBALE (window.JYKelvin): pilota e tiene in sync TUTTI i controlli
   presenti in pagina — lo slider nel popover header [data-k-slider], lo slider
   nell'hero [data-k-hero-slider], i preset [data-k-preset], i readout. */
(function () {
  "use strict";

  var MIN = 3000, MAX = 7000, DEFAULT = 6000;
  var STORE_KEY = "jy-kelvin-v1";

  // Stop di riferimento Kelvin → RGB (blackbody approssimato, taratura JEYEFFE)
  var STOPS = [
    { k: 3000, c: [255, 158, 66] },
    { k: 4300, c: [255, 197, 142] },
    { k: 5000, c: [255, 228, 206] },
    { k: 6000, c: [255, 246, 240] },
    { k: 6500, c: [255, 255, 255] },
    { k: 7000, c: [220, 233, 255] }
  ];

  function clamp(v) { return Math.max(MIN, Math.min(MAX, v)); }

  function kelvinToRgb(k) {
    k = clamp(k);
    for (var i = 0; i < STOPS.length - 1; i++) {
      var a = STOPS[i], b = STOPS[i + 1];
      if (k >= a.k && k <= b.k) {
        var t = (k - a.k) / (b.k - a.k);
        return [
          Math.round(a.c[0] + (b.c[0] - a.c[0]) * t),
          Math.round(a.c[1] + (b.c[1] - a.c[1]) * t),
          Math.round(a.c[2] + (b.c[2] - a.c[2]) * t)
        ];
      }
    }
    return STOPS[STOPS.length - 1].c;
  }

  function rgbCss(c) { return "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")"; }

  function descriptor(k) {
    if (k < 3500) return "Bianco caldo · giallo";
    if (k < 4700) return "Bianco caldo";
    if (k < 5600) return "Bianco neutro";
    if (k < 6300) return "Bianco puro";
    if (k < 6800) return "Bianco freddo";
    return "Bianco ghiaccio · blu";
  }

  var current = DEFAULT;
  var listeners = [];

  function apply(k, save) {
    k = clamp(parseInt(k, 10) || DEFAULT);
    current = k;
    var col = rgbCss(kelvinToRgb(k));
    document.documentElement.style.setProperty("--jy-kelvin-color", col);

    var sliders = document.querySelectorAll("[data-k-slider],[data-k-hero-slider]");
    for (var i = 0; i < sliders.length; i++) {
      if (parseInt(sliders[i].value, 10) !== k) sliders[i].value = k;
    }
    var vals = document.querySelectorAll("[data-k-value]");
    for (var j = 0; j < vals.length; j++) vals[j].textContent = k + " K";
    var descs = document.querySelectorAll("[data-k-desc]");
    for (var d = 0; d < descs.length; d++) descs[d].textContent = descriptor(k);
    var outs = document.querySelectorAll("[data-k-hero-out]");
    for (var o = 0; o < outs.length; o++) outs[o].textContent = k + "K · " + descriptor(k);
    var chips = document.querySelectorAll("[data-k-preset]");
    for (var c = 0; c < chips.length; c++) {
      chips[c].classList.toggle("is-active", parseInt(chips[c].getAttribute("data-k-preset"), 10) === k);
    }

    if (save) { try { localStorage.setItem(STORE_KEY, String(k)); } catch (e) {} }
    for (var l = 0; l < listeners.length; l++) { try { listeners[l](k, col); } catch (e) {} }
  }

  // API globale (usabile da altri script, es. se servisse un terzo controllo)
  window.JYKelvin = {
    set: function (k) { apply(k, true); },
    get: function () { return current; },
    color: function () { return rgbCss(kelvinToRgb(current)); },
    onChange: function (fn) { if (typeof fn === "function") listeners.push(fn); }
  };

  // Popover header: sposta il pannello in <body> (l'header sticky di Dawn usa
  // transform e altrimenti ancorerebbe il position:fixed) + toggle/chiudi.
  function initPanel(root) {
    if (!root || root.dataset.jyKelvinReady) return;
    root.dataset.jyKelvinReady = "1";
    var panel = root.querySelector(".jy-kelvin__panel");
    var toggle = root.querySelector("[data-k-toggle]");
    if (panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    function open() { if (panel) panel.classList.add("is-open"); if (toggle) toggle.setAttribute("aria-expanded", "true"); }
    function close() { if (panel) panel.classList.remove("is-open"); if (toggle) toggle.setAttribute("aria-expanded", "false"); }
    if (toggle) toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      if (panel && panel.classList.contains("is-open")) { close(); } else { open(); }
    });
    var closeBtn = panel && panel.querySelector("[data-k-close]");
    if (closeBtn) closeBtn.addEventListener("click", close);
    document.addEventListener("click", function (e) {
      if (panel && panel.classList.contains("is-open") && !panel.contains(e.target) && !root.contains(e.target)) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  function wireControl(el) {
    if (el.dataset.kWired) return;
    el.dataset.kWired = "1";
    if (el.hasAttribute("data-k-preset")) {
      el.addEventListener("click", function () { apply(this.getAttribute("data-k-preset"), true); });
    } else {
      el.addEventListener("input", function () { apply(this.value, true); });
    }
  }

  function wire() {
    var i, els;
    els = document.querySelectorAll("[data-jy-kelvin]");
    for (i = 0; i < els.length; i++) initPanel(els[i]);
    els = document.querySelectorAll("[data-k-slider],[data-k-hero-slider],[data-k-preset]");
    for (i = 0; i < els.length; i++) wireControl(els[i]);

    // All'apertura del sito si parte SEMPRE da 6000K (bianco puro), la
    // temperatura piu' venduta. La scelta dell'utente vale per la sessione.
    apply(DEFAULT, false);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wire);
  } else {
    wire();
  }
  // Re-wire se una sezione viene ricaricata nell'editor del tema
  document.addEventListener("shopify:section:load", wire);
})();
